import React from 'react';
import { Wrapper } from './Theme';
import { CreateCampaignForm } from '../CreateCampaignForm/CreateCampaignForm';
import { SendTextMessege } from './SendTextMessege/SendTextMessege';
import { setCardContent } from 'services/api/communication';
import { useDispatch } from 'react-redux';
export const TextMessege = ({activeStep,formik,setCardName,setActiveStep,campaignType = "sms"}) => {
  const dispatch = useDispatch()
    const renderContent = () => {
        switch (activeStep) {
          case 0:
            return (
           <CreateCampaignForm formik={formik} onNext={()=>{setActiveStep(2)}} 
           onBack={()=>dispatch(setCardContent("Create Campaign"))}/>
            );
          case 1:
            return (
                <></>
            );
          case 2:
            return (
              <SendTextMessege onBack={()=>{setActiveStep(0)}} formik={formik} setCardName={setCardName} campaignType={campaignType}/>
            );
    
          default:
            return;
        }
      };
    
      return <Wrapper>{renderContent()}</Wrapper>;
};
